import styled, { css } from 'styled-components'
import { Icon } from 'components'

export const DropIcon = styled(Icon)(
  ({ up }) => css`
    transform: rotate(${up ? '-180deg' : '0deg'});
    transition: 0.25s;
  `,
)
